import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';

import { JoyrideService } from './joyride.service';
import { JoyrideOverlayComponent } from './joyride.component';
import { JoyrideStepDirective } from './joyride.directive';
import { JOYRIDE_DIALOG_DATA, JOYRIDE_DIALOG_FUNCTIONS } from './joyride.tokens';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [ 
        JoyrideOverlayComponent,
        JoyrideStepDirective
    ],
    imports: [
        OverlayModule,
        SharedModule
    ],
    exports: [
        JoyrideStepDirective
    ],
    providers: [
        JoyrideService,
        {
            provide: JOYRIDE_DIALOG_DATA, 
            useValue: JOYRIDE_DIALOG_DATA
        },
        {
            provide: JOYRIDE_DIALOG_FUNCTIONS, 
            useValue: JOYRIDE_DIALOG_FUNCTIONS
        }
    ]
})
export class JoyrideModule {}